export const DEFAULT_PREPA_IMAGE = "https://squaregym.fr/app/uploads/2023/12/abdos-avec-poids-2.jpg";
export const DEFAULT_AVATAR = "/img/user_avatar.jpg";

export const DEFAULT_EXERCISE_FORM = {
  nom: "",
  description: "",
  lien_photo: "",
  lien_video: "",
  programme: "",
};

export const DEFAULT_ASSIGNMENT_FORM = {
  date_realisation: "",
  repetitions: "",
};

export function getTodayInputDate() {
  return new Date().toISOString().slice(0, 10);
}

export function safeDate(value) {
  if (!value) return null;

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateFr(value) {
  const date = safeDate(value);

  if (!date) return "Date non renseignée";

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);
}

export function getAdherentName(adherent) {
  return (
    [adherent?.prenom, adherent?.nom].filter(Boolean).join(" ") || "Judoka"
  );
}

export function getAdherentSubtitle(adherent) {
  return adherent?.club || adherent?.genre || "Profil judoka";
}

export function sortExercises(exercises = []) {
  return [...exercises].sort((a, b) =>
    String(a?.nom || "").localeCompare(String(b?.nom || ""), "fr"),
  );
}

export function sortAssignedResults(results = []) {
  return [...results].sort((a, b) => {
    const dateA = safeDate(a?.date_realisation)?.getTime() || 0;
    const dateB = safeDate(b?.date_realisation)?.getTime() || 0;

    if (dateA !== dateB) return dateB - dateA;

    return String(a?.Exercice?.nom || "").localeCompare(
      String(b?.Exercice?.nom || ""),
      "fr",
    );
  });
}

export function dedupeAdherents(adherents = []) {
  const map = new Map();

  adherents.forEach((adherent) => {
    if (!adherent?.id) return;

    const previous = map.get(Number(adherent.id)) || {};

    map.set(Number(adherent.id), {
      ...previous,
      ...adherent,
      id: Number(adherent.id),
    });
  });

  return Array.from(map.values()).sort((a, b) => {
    const nameA = getAdherentName(a);
    const nameB = getAdherentName(b);

    return nameA.localeCompare(nameB, "fr");
  });
}

export function normalizeNullableString(value) {
  const clean = String(value || "").trim();

  return clean || null;
}

export function normalizeExercisePayload(form) {
  return {
    nom: String(form.nom || "").trim(),
    description: normalizeNullableString(form.description),
    lien_photo: normalizeNullableString(form.lien_photo),
    lien_video: normalizeNullableString(form.lien_video),
    programme: normalizeNullableString(form.programme),
  };
}

export function normalizeExerciseFormFromApi(exercise) {
  return {
    nom: exercise?.nom || "",
    description: exercise?.description || "",
    lien_photo: exercise?.lien_photo || "",
    lien_video: exercise?.lien_video || "",
    programme: exercise?.programme || "",
  };
}

export function validateExerciseForm(form) {
  if (!String(form.nom || "").trim()) {
    return "Le nom de l'exercice est obligatoire.";
  }

  return "";
}

export function validateAssignmentForm({
  selectedExercise,
  selectedAdherentIds,
  assignmentForm,
}) {
  if (!selectedExercise?.id) {
    return "Sélectionnez d'abord un exercice à attribuer.";
  }

  if (!selectedAdherentIds?.length) {
    return "Sélectionnez au moins un judoka ou un groupe.";
  }

  if (!assignmentForm.date_realisation) {
    return "Sélectionnez une date prévue pour l'exercice.";
  }

  if (
    assignmentForm.repetitions !== "" &&
    assignmentForm.repetitions !== null &&
    Number(assignmentForm.repetitions) < 0
  ) {
    return "Le nombre de répétitions ne peut pas être négatif.";
  }

  return "";
}

export function toBoolean(value) {
  if (value === true || value === 1) return true;

  if (value === false || value === 0 || value === null || value === undefined) {
    return false;
  }

  const normalized = String(value).trim().toLowerCase();

  return ["true", "1", "yes", "oui", "on"].includes(normalized);
}

export function buildResultKey(result) {
  const adherentId = result?.adherent_id || result?.Adherent?.id || "a";
  const exerciseId = result?.prepa_physique_id || result?.Exercice?.id || "e";
  const date = result?.date_realisation || "date";

  return result?.id || `${adherentId}-${exerciseId}-${date}`;
}

export function buildPrepaStats({
  exercises = [],
  groups = [],
  allAdherents = [],
  assignedResults = [],
}) {
  const done = assignedResults.filter((result) =>
    toBoolean(result?.is_done),
  ).length;

  const pending = assignedResults.length - done;

  return {
    exercisesCount: exercises.length,
    groupsCount: groups.length,
    adherentsCount: allAdherents.length,
    assignedCount: assignedResults.length,
    doneCount: done,
    pendingCount: pending,
  };
}